import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { SHOP_FEATURE, ShopState, StateWithShop } from '../shop-state';

export const getShopState: MemoizedSelector<StateWithShop, ShopState> = createFeatureSelector<ShopState>(SHOP_FEATURE);
